import * as React from 'react';
import { VALID_TYPES_TO_RENDER } from './constants';
const isRenderable = item => {
  if (VALID_TYPES_TO_RENDER.includes(typeof item)) {
    return true;
  }
  return false;
};
const isValidArray = el => {
  const isArray = Array.isArray(el);
  if (!isArray) {
    return false;
  }
  const isRenderableArray = el.every(item => isRenderable(item));
  return isRenderableArray;
};
const isValidElement = el => {
  if (isRenderable(el)) {
    return true;
  }
  if (isValidArray(el)) {
    return true;
  }
  if (typeof el === 'object') {
    return /*#__PURE__*/React.isValidElement(el);
  }
  return false;
};
export default isValidElement;